import React, { FC } from 'react'
import { CallUsDropdown } from './CallUsDropdown'
import { CallUsInline } from './CallUsInline'
import { CallUsSchema } from './types'
import { useProcessedSchema } from './useProcessedSchema'
import { useHostServices } from '../../HostServices'

export const CallUs: FC<{
  schema: CallUsSchema[]
}> = ({ schema }) => {
  const { featureFlags } = useHostServices()

  const isFDICBannerEnabled = featureFlags.variation(
    'FF_fdic-digital-signage',
    false,
  )

  const processed = useProcessedSchema(schema)

  if (processed.length === 0) return null

  // If the FDIC Banner is being displayed always use the dropdown instead of inline
  if (isFDICBannerEnabled) return <CallUsDropdown schema={processed} />

  if (processed.length === 1 && !processed[0].forceDropdown)
    return <CallUsInline schema={processed[0]} />

  return <CallUsDropdown schema={processed} />
}
